<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "CardAdditDataForElective",
  props: {
    data_addit: {
      type: Object
    },
    edit_mode: {
      type: Boolean
    }
  },
  data: () => ({
    list_forms_education: [
      "Очная", "Заочная", "Очно-заочная", "Ускорено-заочная"
    ],
    list_level_education: [
      "Бакалавриат", "Магистратура", "Специалитет"
    ]
  }),
  mounted() {

  },
  computed: {
    ...mapState({
      list_educational_programs: state => state.studyEstEukTechMapAdditData.list_educational_programs,
      list_disciplines: state => state.studyEstEukTechMapAdditData.list_disciplines,
      list_chairs: state => state.studyEstEukTechMapAdditData.list_chairs,
      list_curriculums: state => state.studyEstEukTechMapAdditData.list_curriculums,
      list_semesters: state => state.studyEstEukTechMapAdditData.list_semesters,
      list_curriculum_lines: state => state.studyEstEukTechMapAdditData.list_curriculum_lines,
      list_study_years: state => state.studyEstEukTechMapAdditData.list_study_years,
    }),
  },
  methods: {
    ...mapActions({}),
    ...mapMutations({}),
    setLevelEducation(value) {
      this.$emit('setLevelEducation', {
        level_educations: value
      })
    },
    setChairIds(value) {
      this.$emit('setChairIds', {
        chair_ids: value
      })
    },
    setStudyYearId(value) {
      this.$emit('setStudyYearId', {
        study_year_id: value
      })
    },
    setDisciplineId(value) {
      this.$emit('setDisciplineId', {
        discipline_id: value
      })
    },
    setSemesters(value) {
      this.$emit('setSemesters', {
        semesters: value
      })
    },
    setFormEducation(value) {
      this.$emit('setFormEducation', {
        form_education: value
      })
    }
  }
}
</script>

<template>
  <div class="mt-5">
    <v-row justify="center">
      <v-col cols="12" md="4">
        <v-text-field
            label="Образовательные программы"
            :value="'Для всех направлений подготовки'"
            outlined
            hide-details
            rounded
            :readonly="true"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="4">
        <v-autocomplete
            :value="data_addit.level_educations"
            label="Уровень образования"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_level_education"
            @input="setLevelEducation"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            multiple
            item-text="name"
            item-value="id"
            hide-details
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            :value="data_addit.chair_ids"
            label="Кафедры"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_chairs"
            @input="setChairIds"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            item-text="name"
            item-value="id"
            multiple
            hide-details
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            :value="data_addit.study_year_id"
            label="Год обучения"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_study_years"
            @input="setStudyYearId"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            item-text="name"
            item-value="id"
            hide-details
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-autocomplete
            :value="data_addit.discipline_id"
            label="Дисциплина"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_disciplines"
            @input="setDisciplineId"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            item-text="name"
            item-value="id"
            hide-details
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
            :value="data_addit.semesters"
            label="Семестры"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_semesters"
            @input="setSemesters"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            hide-details
            multiple
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="4">
        <v-autocomplete
            :value="data_addit.form_education"
            label="Форма обучения"
            :readonly="!edit_mode"
            :clearable="edit_mode"
            :items="list_forms_education"
            @input="setFormEducation"
            :rules="[v => !!v || 'Обязательное поле не заполнено']"
            :menu-props="{ down: true, offsetY: true }"
            no-data-text="Данные отсутствуют"
            hide-details
            rounded
            outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>